import React from 'react'
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { IResPersonal } from '@/lib/interfaces';

interface IPersonalDetailsSection {
  personal: IResPersonal,
  setPersonal: (personal: IResPersonal) => void
}

function PersonalSection({ personal, setPersonal }: IPersonalDetailsSection) {
  return (
    <section className="space-y-6 p-3 bg-white 
      border-2 border-gray-200 rounded-xl">
      <h2 className="text-xl text-indigo-600 font-medium">
        Personal Details
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="flex flex-col gap-2">
          <Label htmlFor="fullName" className='text-indigo-600 ml-3'>Full Name</Label>
          <Input placeholder="Full Name" id="fullName" value={personal.name} onChange={(e) => setPersonal({ ...personal, name: e.target.value })} />
        </div>
        <div className="flex flex-col gap-2">
          <Label htmlFor="email" className='text-indigo-600 ml-3'>Email</Label>
          <Input placeholder="Email" id="email" type="email" value={personal.email} onChange={(e) => setPersonal({ ...personal, email: e.target.value })} />
        </div>
        <div className="flex flex-col gap-2">
          <Label htmlFor="mobile" className='text-indigo-600 ml-3'>Mobile Number</Label>
          <Input placeholder="Mobile Number" id="mobile" value={personal.mobile} onChange={(e) => setPersonal({ ...personal, mobile: e.target.value })} />
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Label htmlFor="brief" className='text-indigo-600 ml-3'>Brief</Label>
        <Textarea id="brief" placeholder="Professional Brief (Raw text for AI to polish)" 
          className="h-40" value={personal.brief}
          onChange={(e) => setPersonal({ ...personal, brief: e.target.value })} />
      </div>
    </section>
  )
}

export default PersonalSection